<template>
  <div class="goods1">
    <div class="mb20">
      请前往菜单，内容营销＞通用设置，客服一栏进行相关配置。
    </div>
    <div class="mb20">
      需要配置微信客服二维码、客服联系邮箱、客服工作时间、客服联系电话。
    </div>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],

  methods: {},
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/footer/footer1/setting.vue